import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import type { RepositoryUserGroups } from "../../domain/repositories/repository-user-groups";
import { type UUID } from "../../utils/uuid";
import { ListCommandButtons, type ListCommandButtonsProps } from "./list-command-buttons";
import { FormUpdateUserGroup } from "../molecules/form-update-user-group";

export type ListCommandButtonsUserGroupsProps = Omit<
    ListCommandButtonsProps<RepositoryUserGroups>,
    "list" | "createForm" | "listState"
>;

import { store } from "../../store";

@observer
export class ListCommandButtonsUserGroups extends React.Component<ListCommandButtonsUserGroupsProps> {
    constructor(props: ListCommandButtonsUserGroupsProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private async deleteUserGroups(ids: UUID[]): Promise<void> {
        await store.repositoryUserGroups.delete(...ids);
        if (this.props.onDelete) {
            this.props.onDelete(ids);
        }
    }

    public render(): JSX.Element {
        return (
            <ListCommandButtons
                updateForm={FormUpdateUserGroup}
                listState={store.serviceListStates.userGroups}
                {...this.props}
                onDelete={this.deleteUserGroups}
            />
        );
    }
}
